/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
export const getPermissionApplyTable = params => {
  return axios.post(`${base}/permission_apply/query`, params)
}
export const exportPermissionApplyData = params => {
  return axios.get(`${base}/exportPermissionApplyData/${params.id}`, {params})
}
export const createPermissionApplyData = params => {
  return axios.post(`${base}/permission_apply/create`, params)
}

export const passPermissionApplyData = params => {
  return axios.post(`${base}/permission_apply/pass_${params.id}`, params)
}

export const failPassPermissionApplyData = params => {
  return axios.post(`${base}/permission_apply/fail_${params.id}`, params)
}
export const batchPassPermissionApplyData = params => {
  return axios.post(`${base}/permission_apply/batch_pass`, params)
}
export const getPermissionApplyCustomerInfo = params => {
  return axios.get(`${base}/permission_apply/get_admin_${params.id}`, {params})
}



// WEBPACK FOOTER //
// ./src/views/permission-apply/permission-apply.api.js